import { useEffect, useState } from "react";

/** Opt-in, local-only layout diagnostics for browser bugs that emulation cannot show. */
export default function ViewportDebug() {
  const enabled =
    new URLSearchParams(location.search).get("viewportDebug") === "1";
  const [report, setReport] = useState<Record<string, unknown>>({});
  const [release, setRelease] = useState("");
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    fetch("/release.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (active && data?.release) setRelease(data.release);
      })
      .catch(() => {});
    const round = (n: number) => Math.round(n * 100) / 100;
    const box = (selector: string) => {
      const rect = document.querySelector(selector)?.getBoundingClientRect();
      return rect
        ? {
            top: round(rect.top),
            bottom: round(rect.bottom),
            height: round(rect.height),
          }
        : null;
    };
    const sample = () => {
      const vp = window.visualViewport;
      setReport({
        ua: navigator.userAgent,
        window: { width: innerWidth, height: innerHeight, scrollY },
        visual: vp
          ? {
              height: round(vp.height),
              width: round(vp.width),
              pageTop: round(vp.pageTop),
              offsetTop: round(vp.offsetTop),
              scale: round(vp.scale),
            }
          : null,
        body: box("body"),
        app: box(".app-shell"),
        nav: box(".bottom-nav"),
      });
    };
    sample();
    const timer = setInterval(sample, 500);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [enabled]);
  if (!enabled) return null;
  return (
    <aside className="viewport-debug" aria-label="布局诊断">
      <div>
        <strong>布局诊断 {release}</strong>
        <button
          onClick={() => {
            navigator.clipboard
              ?.writeText(JSON.stringify({ release, ...report }, null, 2))
              .then(() => setCopied(true))
              .catch(() => setCopied(false));
          }}
        >
          {copied ? "已复制" : "复制数据"}
        </button>
      </div>
      <pre>{JSON.stringify(report, null, 2)}</pre>
    </aside>
  );
}
